export const CHAT_COMPOSER_DRAFT_STORAGE_KEY = 'r2.chat.composer.draft';
export const GROUP_CHAT_COMPOSER_DRAFT_STORAGE_KEY = 'r2.group-chat.composer.draft';
export const CHAT_COMPOSER_HEIGHT_STORAGE_KEY = 'r2.chat.composer.height.px';
export const CHAT_COMPOSER_MAX_HEIGHT_PX = 359;
